<template>
    <form class="pr search-form" @submit.prevent="doSubmit">
        <i class="pa m i-search"></i>
        <input type="search" class="input" maxlength="200" placeholder="输入您想了解的内容" v-model="$store.state.keyword" />
    </form>
</template>

<script>
import store from "./store";

export default {
    store,
    methods:{
        doSubmit(){
            if(this.$store.state.keyword){
                this.$route.fullPath==="/q"?this.$store.dispatch("change"):this.$router.push('/q');
            }
            else
            {
                this.$store.commit("clear");
            }
        }
    }
}
</script>

<style>
.i-search{background-image:url(data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%201024%201024%22%20version%3D%221.1%22%3E%3Cpath%20fill%3D%22%23AAA%22%20d%3D%22M1003.008%20952.832l-169.984-182.272c69.12-82.944%20107.008-186.88%20107.008-295.936%200-256-208.384-463.872-464.384-463.872-256%200-463.872%20208.384-463.872%20463.872%200%20256%20208.384%20463.872%20463.872%20463.872%2067.072%200%20131.584-13.824%20192-41.472%2017.92-8.192%2026.112-29.184%2017.408-47.104-8.192-17.92-29.184-26.112-47.104-17.408-51.2%2023.04-105.984%2035.328-162.304%2035.328-216.576%200-392.704-176.128-392.704-392.704%200-216.576%20176.128-392.704%20392.704-392.704%20216.576%200%20392.704%20176.128%20392.704%20392.704%200%20101.888-38.912%20198.656-109.568%20271.872-13.824%2014.336-13.312%2036.864%201.024%2050.688%201.024%201.024%202.56%201.536%203.584%202.048%201.024%201.536%201.536%203.072%202.56%204.608l184.832%20197.632c6.656%207.68%2016.384%2011.264%2026.112%2011.264%208.704%200%2017.408-3.072%2024.576-9.728C1015.808%20989.696%201016.32%20967.168%201003.008%20952.832L1003.008%20952.832zM1003.008%20952.832%22/%3E%3C/svg%3E) !important;}
.search-form{font-size:.416rem;}
.search-form>.m{width:3em;height:100%;background-position:.8em 50%;background-size:1.2em;}
.search-form>.input{width:100%;margin:0;box-sizing:border-box;border:none;font-size:1em;padding:.4em .4em .4em 3em;border-radius:3em;background-color:#F5F5F5;outline:none;}
.header-inner>.search-form{flex:1;}

</style>


// WEBPACK FOOTER //
// src/components/search-form/view.vue